// The Tribys mark ("Rise"): the letter T folded into an offset tent — half the
// crossbar drops to the ground, the other half clears the ridge, the stem
// stands as the pole. The grounded half welds into the pole with a sharp
// crease; the pole rounds into the raised half. Upright, no lean.
// Colors are literals on purpose: the logo is an exact-color artifact.

const MARK = (
  <g fill="none" strokeWidth={13} strokeLinecap="round">
    <path strokeLinejoin="miter" d="M26 70 L62 37 L62 84" />
    <path strokeLinejoin="round" d="M62 52 Q62 37 70 29.7 L74 26" />
  </g>
);

// Bare mark, for use on any ground.
export function Mark({ size = 32, color = '#FF6F61' }: { size?: number; color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" stroke={color} aria-hidden="true">
      {MARK}
    </svg>
  );
}

// The app tile: white mark on the coral squircle (nav, footer, favicon, app icon).
export function LogoTile({ size = 32 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" aria-hidden="true">
      <rect width="100" height="100" rx="22" fill="#FF6F61" />
      <g stroke="#FFFFFF" transform="translate(16 16) scale(0.68)">
        {MARK}
      </g>
    </svg>
  );
}

// The complete wordmark: the mark as the display-initial T + "ribys" in
// Poppins Bold, outlined to paths (no font dependency). Same artwork as
// static/wordmark.svg — keep them in sync.
export function Wordmark({ height = 34 }: { height?: number }) {
  return (
    <svg
      height={height}
      viewBox="-2 -146 370.1 176"
      style={{ width: 'auto', display: 'block' }}
      role="img"
      aria-label="tribys"
    >
      <g fill="none" stroke="#FF6F61" strokeWidth="13" strokeLinecap="round" transform="translate(-37.90 -175.90) scale(1.943662)"><path strokeLinejoin="miter" d="M26 70 L62 37 L62 84"/><path strokeLinejoin="round" d="M62 52 Q62 37 70 29.7 L74 26"/></g><g fill="#263238"><path transform="translate(110.86 0) scale(0.100000 -0.100000)" d="M408 564V383H361Q297 383 265.0 355.5Q233 328 233 259V0H62V558H233V465Q263 511 308.0 537.5Q353 564 408 564Z"/><path transform="translate(152.16 0) scale(0.100000 -0.100000)" d="M46 708Q46 748 74.5 774.5Q103 801 148 801Q192 801 220.5 774.5Q249 748 249 708Q249 669 220.5 642.5Q192 616 148 616Q103 616 74.5 642.5Q46 669 46 708ZM233 558V0H62V558Z"/><path transform="translate(180.16 0) scale(0.100000 -0.100000)" d="M405 566Q474 566 530.0 531.0Q586 496 618.5 431.0Q651 366 651 280Q651 194 618.5 128.5Q586 63 530.0 27.5Q474 -8 405 -8Q346 -8 302.0 15.5Q258 39 233 78V0H62V740H233V479Q257 518 302.0 542.0Q347 566 405 566ZM354 417Q303 417 267.5 380.0Q232 343 232 279Q232 215 267.5 178.0Q303 141 354 141Q405 141 441.0 178.5Q477 216 477 280Q477 344 441.5 380.5Q406 417 354 417Z"/><path transform="translate(246.56 0) scale(0.100000 -0.100000)" d="M632 558 282 -265H98L226 19L-1 558H190L319 209L447 558Z"/><path transform="translate(308.26 0) scale(0.100000 -0.100000)" d="M32 183H201Q204 154 228.0 136.0Q252 118 287 118Q319 118 336.5 130.5Q354 143 354 163Q354 187 329.0 198.5Q304 210 248 224Q188 238 148.0 253.5Q108 269 79.0 302.5Q50 336 50 393Q50 441 76.5 480.5Q103 520 154.5 543.0Q206 566 277 566Q382 566 442.5 514.0Q503 462 512 376H354Q350 405 328.5 422.0Q307 439 272 439Q242 439 226.0 427.5Q210 416 210 396Q210 372 235.5 360.0Q261 348 315 336Q377 320 416.0 304.5Q455 289 484.5 254.5Q514 220 515 162Q515 113 487.5 74.5Q460 36 408.5 14.0Q357 -8 289 -8Q216 -8 159.0 17.0Q102 42 69.0 85.5Q36 129 32 183Z"/></g>
    </svg>
  );
}
